<template>
  <div class="contextual-help" :id="title ? 'help-' + title : ''">
    <md-icon>help</md-icon>
    <a :href="link" target="_blank">{{ expandedText }}</a>
  </div>
</template>
<script>
import api from "@/api";
export default {
  data: () => ({
    environment: api.props.config.environment,
    expandedText: String,
  }),
  props: {
    link: null,
    maxSize: {
      // width size for media query, default makes mini link
      type: String,
      default: "9999"
    },
    title: String // if there are more than one help-link in one page, we need this to sepcify
  },
  mounted() {
    var mq = window.matchMedia("(max-width:" + this.maxSize + "px)");
    var container = document.querySelector(
      ".contextual-help" + (this.title ? "#help-" + this.title : "")
    );
    if (this.environment === "beta") {
      this.expandedText = "More Info (BETA) >>";
    } else {
      this.expandedText = "More Info >>";
    }
    mq.addListener((mq) => {
      this.containerClassLogic(mq, container);
    });
    this.containerClassLogic(mq, container);
  },
  methods: {
    containerClassLogic(mq, container) {
      const elementClass = "contextual-help-mini";
      if (mq.matches) {
        container.classList.add(elementClass);
        if (this.environment === "beta") {
          container.classList.add("beta");
        }
      } else {
        container.classList.remove(elementClass);
        if (this.environment === "beta") {
          container.classList.remove("beta");
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/md/_variables.scss";

.contextual-help {
  background: linear-gradient(60deg, $brand-primary, $brand-primary);
  border-radius: 11px;
  height: 22px !important;
  width: 122px;
  margin:0 10px;
}
.contextual-help-mini {
  width: 22px;
  position: absolute;
  top: -11px;
  right: 11px;
  transition: width 1s;
  overflow: hidden;
  white-space: nowrap;
  &:hover {
    width: 122px;
  }
}
.beta {
  &:hover {
    width: 165px;
  }
}
.md-icon {
  font-size: 20px !important;
  min-width: 22px !important;
  width: 22px !important;
  height: 22px !important;
  color:white !important;
  line-height: 0px !important;
}
a {
  margin-left: 7px;
  margin-right: 12px;
  text-decoration: underline;
  font-size: 13px;
  font-weight: bold;
  font-family: "Montserrat", "Roboto", "Helvetica", "Arial", sans-serif;
  cursor: pointer !important;
  color:white !important;
}
div > a:hover,
div > a:focus {
  font-size: 13px !important;
  font-weight: bold !important;
  text-decoration: underline !important;
  color: white !important;
}
</style>
